import { regionNames } from "../../utilities";

import { pestsAndPathogensSharedStateDefinitions } from "./pests-and-pathogens/info";
import { springFreezeDamageSharedStateDefinitions } from "./spring-freeze-damage/info";
import { getInitBiomass } from "./getInitBiomass";

const sharedStateDefinitions = {
  'regionSelector': {
    options: regionNames,
    initValue: regionNames,
    props: {
      listTypeSingular: 'Region',
      listTypePlural: 'Regions',
    }
  },
  'departureSelector': {
    options: {
      'Risk For': ['Current Year'],
      'Compare Today To': ['Last Year (%)', 'Normal (%)', 'Last Year (Days)', 'Normal (Days)']
    },
    initValue: 'Current Year',
    props: {
      label: (value) => {
        if (value === 'Current Year') {
          return 'Current Year';
        } else {
          return `Departure From ${value}`;
        }
      },
      title: ''
    }
  },
  'biomassThresholdSelector': {
    onNavChange: (_, { newSubTab }) => ([getInitBiomass(newSubTab)]),
    initValue: ({ selectedSubTab }) => ([getInitBiomass(selectedSubTab)])
  },
  ...pestsAndPathogensSharedStateDefinitions,
  ...springFreezeDamageSharedStateDefinitions
};

export default sharedStateDefinitions;